import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useKeycloak } from "@react-keycloak/web";
import TranslatorService from "../../../services/Translator/TranslatorService";
import "../../../assets/css/global.css";

const UserProfileTemplate = ({ userInfos }) => {
  const { keycloak } = useKeycloak();
  const { i18n } = useTranslation();
  const username = keycloak.tokenParsed.preferred_username;
  const selectedLanguage = i18n.language;
  const roles = keycloak.tokenParsed.realm_access.roles;
  const role = roles.includes("admin")
    ? "Administrador"
    : roles.includes("superuser")
    ? "Super Usuário"
    : "Usuário";

  const changeLanguage = (e) => {
    const language = e.target.value;
    i18n.changeLanguage(language);
  };

  const {
    totalSpentTokens,
    trialPeriodDays,
    trialPeriodRemainingDays,
    trialRemainingTokens,
  } = userInfos;
  let { createdAt } = userInfos;
  createdAt = new Date(createdAt).toLocaleDateString();

  return (
    <div className="main d-flex flex-column vh-100">
      <div className="breadcrumb d-flex align-items-center flex-sh-0">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/profile">
                <FontAwesomeIcon icon={faGear} />
                &ensp;
                <TranslatorService path="profilePanel.breadcrumb" />
              </a>
            </li>
          </ol>
        </nav>
      </div>
      <div className="flex-grow-1 overflow-auto pt-20">
        <div className="container">
          <div className="row">
            <div className="block-config-data">
              <div className="title">
                <h2>
                  <TranslatorService path="profilePanel.myData" />
                </h2>
              </div>
              <div className="options d-flex">
                <form>
                  <>
                    <div className="mb-3">
                      <label for="inputUsername" className="form-label">
                        <TranslatorService path="profilePanel.loginLabel" />:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputUsername"
                        value={username}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label for="inputRole" className="form-label">
                        <TranslatorService path="profilePanel.positionLabel" />:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputRole"
                        value={role}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label for="inputCreatedAt" className="form-label">
                        <TranslatorService path="profilePanel.createdAtLabel" />
                        :
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputCreatedAt"
                        value={createdAt}
                        disabled
                      />
                    </div>
                    {roles.includes("plans-trial") && (
                      <>
                        <div className="mb-3">
                          <label for="inputTrialPeriod" className="form-label">
                            <TranslatorService path="profilePanel.trialPeriodLabel" />
                            :
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputTrialPeriod"
                            value={trialPeriodDays}
                            disabled
                          />
                        </div>
                        <div className="mb-3">
                          <label
                            for="inputTrialPeriodRemainingDays"
                            className="form-label"
                          >
                            <TranslatorService path="profilePanel.trialPeriodRemainingDaysLabel" />
                            :
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputTrialPeriodRemainingDays"
                            value={trialPeriodRemainingDays}
                            disabled
                          />
                        </div>
                      </>
                    )}
                    <div className="mb-3">
                      <label for="inputSpentTokens" className="form-label">
                        <TranslatorService path="profilePanel.spentTokensLabel" />
                        :
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputSpentTokens"
                        value={totalSpentTokens}
                        disabled
                      />
                    </div>
                    {roles.includes("plans-trial") && (
                      <div className="mb-3">
                        <label
                          for="inputTrialRemainingTokens"
                          className="form-label"
                        >
                          <TranslatorService path="profilePanel.trialRemainingTokensLabel" />
                          :
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputTrialRemainingTokens"
                          value={trialRemainingTokens}
                          disabled
                        />
                      </div>
                    )}
                  </>
                  {/*
                  <button type="submit" className="btn btn-primary" disabled>
                    <FontAwesomeIcon icon={faSave} />
                    &nbsp; <TranslatorService path="profilePanel.save" />
                  </button> 
                  // TODO: Descomentar quando tiver ou se tiver a possibilidade do usuário editar suas infos
                  */}
                </form>
              </div>
            </div>
            <div className="block-config-data mt-50">
              <div className="title">
                <h2>
                  <TranslatorService path="profilePanel.idioms" />
                </h2>
                <div class="form-group mt-20">
                  <select
                    id="language-select"
                    class="form-select"
                    onChange={changeLanguage}
                  >
                    <option
                      value="pt-BR"
                      class="option-with-icon"
                      selected={selectedLanguage === "pt-BR"}
                    >
                      <i class="fa-solid fa-flag"></i>{" "}
                      <TranslatorService path="profilePanel.ptBr" />
                    </option>
                    <option
                      value="en-US"
                      class="option-with-icon"
                      selected={selectedLanguage === "en-US"}
                    >
                      <i class="fa-solid fa-flag"></i>{" "}
                      <TranslatorService path="profilePanel.enUs" />
                    </option>
                    <option
                      value="es"
                      class="option-with-icon"
                      selected={selectedLanguage === "es"}
                    >
                      <i class="fa-solid fa-flag"></i>{" "}
                      <TranslatorService path="profilePanel.es" />
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="block-config-data mt-50 mb-50">
              <div className="title">
                <h2>
                  <TranslatorService path="profilePanel.support" />
                </h2>
                <p>
                  <TranslatorService path="profilePanel.descriptionSupport" />
                  <a href="mailto:suporte@iron.com.br" target="__blank">
                    suporte@iron.com.br
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileTemplate;
